import React from 'react';
import { FormControl, InputLabel, Select, SelectProps, MenuItem } from '@mui/material';
import { Control, Controller, FieldError } from 'react-hook-form';

interface FormSelectProps extends Omit<SelectProps, 'onChange' | 'label' | 'value' | 'error'> {
  name: string;
  control: Control<any, any>;
  error?: FieldError;
  label: string;
  options: { value: string; label: string }[];
}

export function FormSelect({ name, control, error, label, options, ...props }: FormSelectProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl fullWidth size="small" error={!!error}>
          <InputLabel sx={{ fontSize: '0.875rem' }}>{label}</InputLabel>
          <Select
            label={label}
            {...field}
            value={field.value ?? ''}
            disabled={props.disabled}
            sx={{
              '& .MuiOutlinedInput-notchedOutline': { borderRadius: 0 },
              '& .MuiSelect-select': {
                fontSize: '0.875rem',
              },
            }}
          >
            {options.map(option => (
              <MenuItem key={option.value} value={option.value} sx={{ fontSize: '0.875rem' }}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
}

export default FormSelect;
